<template>
<div>
    <div class="hear fl1">
    <div @click="shouye" class="hear_logo">
       <img src="@/assets/login/logo.20b2deed.png" alt="" />
    </div>

        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>活动管理</el-breadcrumb-item>
  <el-breadcrumb-item>活动列表</el-breadcrumb-item>
  <el-breadcrumb-item>活动详情</el-breadcrumb-item>
</el-breadcrumb> -->


    <div class="index_Navigation fl1">
      <div
        style="display: flex; justify-content: center"
        v-for="(item, index) in hearList"
        :key="index"
        class="Navigation"
        :class="index == chenkout ? 'Navigation1' : ''"
        @click="checkout(index)"
      >
        <div>
          {{ item }}
        </div>
        <div v-if="index == chenkout" class="hengxian"></div>
      </div>
      <!-- <div class="btn">
        <el-button class="el-buttons" size="small" @click="open" plain
          >豫资签登录</el-button
        >
      </div> -->
    </div>

  </div>
</div>
</template>
<script>
export default {
  name: "hear",
  props: {
    //props列表
    num: Number,
  },
  data() {
    return {
      chenkout: 0,
      dialogVisible: false,
      hearList: ["首页", "支付和开票", "企业认证", "我的"],
    };
  },
  created(e) {
    this.chenkout = sessionStorage.getItem("chenkout");
    console.log("当前", e);
  },
  methods: {
    shouye() {
      this.$router.push({ name: "index" });
    },
    open() {
      this.$alert("检测不到豫资签", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
    checkout(index) {
      this.chenkout = index;
      sessionStorage.setItem("chenkout", this.chenkout);
      console.log(index);
      if (index == 0) {
        this.$router.push({ name: "index" });
      }
      if (index == 1) {
        this.$router.push({ name: "/Navbar" });
      }
      if (index == 2) {
        this.$router.push({ name: "agenciesName" });
      }
      if (index == 3) {
        this.$router.push({ name: "userCenter" });
      }
    },
  },
};
</script>
<style scoped lang="scss">

.el-buttons {
  width: 120px;
  height: 40px;
  color:#1795FF;
  border: 1px solid #1795FF;
}

.Navigation {
  width: 100px;
  height: 30px;
  color: #333333;
  font-size: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.hengxian {
  height: 2px;
  width: 19px;
  background-color: #1795FF;
  position: relative;
  top: 37%;
}

.index_Navigation {
  // width: 290px;
  height: 26px;
  /* position: relative;
  left: 855px; */

  justify-content: space-between
}

.Navigation1 {

  color: #1795FF;
  display: inline-block
}
/* 
.hear_logo {

  background-color: #1795FF;
  width: 138px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
} */
.hear_logo {
  width:200px;
height: 43px;
display: flex;
justify-content: center;
align-items: center;
color: #FFFFFF;
box-sizing: border-box;
img{
width: 100%;
height: 100%;
margin-left: 20px;
}
}

.hear {
  /* width: 74%; */
  height: 69px;
  padding:0 0%;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 9px 1px rgba(103, 103, 103, 0.15);
  /* align-items: center; */
}

.fl1 {
  display: flex;
  align-items: center;
  justify-content:space-between ;
}
</style>


// WEBPACK FOOTER //
// src/components/hear.vue